import { useState, useEffect } from "react";
import { FiMoon, FiSun, FiGlobe } from "react-icons/fi";
import { Container, Row, Col } from "reactstrap";
import SocialIcons from "../SocialIcon/SocialIcons";
import { Topbar } from "./Header";
import { useTranslation } from "react-i18next";

const DEFAULT_FONT_SIZE = 16;

const HeaderToolbar = ({ SocialIconsData }) => {
  const { t, i18n } = useTranslation();

  const [lang, setLang] = useState("gu");
  const [fontSize, setFontSize] = useState(DEFAULT_FONT_SIZE);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Load saved language from localStorage and apply to html tag
  useEffect(() => {
    const savedLang = localStorage.getItem("lang") || "gu";
    setLang(savedLang);
    i18n.changeLanguage(savedLang);
    document.documentElement.lang = savedLang;
  }, [i18n]);

  const handleLanguageChange = (e) => {
    const selectedLang = e.target.value;
    setLang(selectedLang);
    i18n.changeLanguage(selectedLang);
    localStorage.setItem("lang", selectedLang);
    document.documentElement.lang = selectedLang;
  };

  // Font size & dark mode
  useEffect(() => {
    document.documentElement.style.fontSize = `${fontSize}px`;

    if (isDarkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }

    const contrastWarningId = "contrast-warning";
    const existing = document.getElementById(contrastWarningId);
    if (existing) existing.remove();

    if (isDarkMode) {
      const color = window.getComputedStyle(document.body).color;
      const rgb = color.match(/\d+/g)?.map(Number);
      const isLowContrast = rgb && rgb.every((v) => v > 150);

      if (isLowContrast) {
        const warning = document.createElement("div");
        warning.id = contrastWarningId;
        warning.textContent =
          "⚠️ Text color is too light for dark background. Adjust for readability.";
        warning.style.color = "#ff0000";
        warning.style.background = "#fff";
        warning.style.padding = "5px 10px";
        warning.style.textAlign = "center";
        document.body.prepend(warning);
      }
    }

    return () => {
      const warn = document.getElementById(contrastWarningId);
      if (warn) warn.remove();
    };
  }, [isDarkMode, fontSize]);

  const toggleDarkMode = () => setIsDarkMode((prev) => !prev);

  return (
    //sm:hidden use for hide on the mobile
    <Topbar
      className={`home-business-topbar border-[#0000001a]  header-with-topbar h-15 ${
        isDarkMode ? "bg-[#121212]" : "bg-white"
      }`}
    >
      <Container fluid>
        <Row className="flex flex-nowrap items-center justify-between overflow-x-auto whitespace-nowrap px-1 gap-2">
          {/* Social Icons */}
          <Col className="col-12 text-center md:text-start col-md-auto me-auto ps-lg-0 sm:hidden">
            <SocialIcons
              theme="social-icon-style-01"
              size="md"
              iconColor={isDarkMode ? "White" : "dark"}
              data={SocialIconsData}
            />
          </Col>

          {/* Phone Number */}
          <Col className="col-auto text-end lg:px-0 sm:hidden">
            <span className="top-bar-contact-list py-[9px] px-[18px] text-[13px] inline-block float-left">
              <i className="feather-phone-call text-darkgray mr-[6px] text-md relative top-[1px] text-[17px]" />
              <span className="text-[1.1em] color-dark">
                {t("phone")}: +91 82008 20261 | +91 84013 61024
              </span>
            </span>
          </Col>

          {/* Font Size Controls */}
          <Col size={7} className="flex items-center px-2 mb-1">
            <div className="flex items-center gap-2">
              <button
                onClick={() => setFontSize((s) => Math.max(s - 1, 12))}
                className="px-2 py-1 border hover:bg-[#FF4F00] hover:text-white rounded-full"
                title="Decrease Font"
              >
                <pre>A-</pre>
              </button>
              <button
                onClick={() => setFontSize(DEFAULT_FONT_SIZE)}
                className="px-2 py-1 border hover:bg-[#FF4F00] hover:text-white rounded-full"
                title="Reset Font"
              >
                A
              </button>
              <button
                onClick={() => setFontSize((s) => s + 1)}
                className="px-2 py-1 border hover:bg-[#FF4F00] hover:text-white rounded-full "
                title="Increase Font"
              >
                <pre>A+</pre>
              </button>
            </div>
          </Col>

          {/* Dark Mode Toggle */}
          <Col size={3} className=" flex items-center px-2">
            <button
              onClick={toggleDarkMode}
              className="flex items-center text-[13px]"
              aria-label="Toggle Dark Mode"
            >
              {isDarkMode ? (
                <>
                  <FiSun className="mr-1" size={20} title="light" />
                </>
              ) : (
                <>
                  <FiMoon className="mr-1" size={20} title="dark" />
                </>
              )}
            </button>
          </Col>

          {/* Language Switcher */}
          <Col size={2} className="col-auto flex items-center border-l">
            {/* <label
              htmlFor="lang-switch"
              className="mr-2 text-[13px] flex items-center"
            >
              <FiGlobe className="mr-1" />
              {t("language")}:
            </label> */}
            <select
              id="lang-switch"
              value={lang}
              onChange={handleLanguageChange}
              className="text-[12px] border rounded px-1 py-[2px] bg-white text-black w-[70px]"
            >
              <option value="en">English</option>
              <option value="hi">हिंदी</option>
              <option value="gu">ગુજરાતી</option>
            </select>
          </Col>
        </Row>
      </Container>
    </Topbar>
  );
};

export default HeaderToolbar;
